import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../Landing/style.css";

// import TODIS_SIGN_IN_FORM from "./form";
import TODIS_LANDING_LINKS from "./mainAdmin";
import TODIS_LANDING_COVER from "../Landing/cover";


const LandingAdmin = () => {

    //handling events 



    //components
    return (
        <div className="todis-landing-main">
            <Container fluid className="px-lg-5 py-lg-4  p-3">
                {/* <img src={logo} width="120" alt="transport community"/> */}
                <Row className="py-5">
                    <Col xxl={6} xl={12} lg={12} md={12} sm={12}><TODIS_LANDING_COVER /></Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={12}><TODIS_LANDING_LINKS /></Col>
                </Row>
            </Container>
        </div>
    )

}


export default LandingAdmin;